import { render } from "./aboutFoundation.vue?vue&type=template&id=7e792ff4&scoped=true"
import script from "./aboutFoundation.vue?vue&type=script&lang=js"
export * from "./aboutFoundation.vue?vue&type=script&lang=js"

import "./aboutFoundation.vue?vue&type=style&index=0&id=7e792ff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e792ff4"]])

export default __exports__